import React from 'react';
import DaTable from './../../common/DaTable'
import Panel from '../../common/layout/Panel'
import DatePicker from 'react-datepicker';
import Button from '../../common/Button';
var imm = require('immutable');


export default class extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            url: '/admin/reports/billing',
            limit: 50,
            offset: 0,
            filter: {},
            datalen: 0,
            datarows: [],
            servermeta: [],
            daterange: imm.Map({
                from: new Date(new Date().getFullYear(), new Date().getMonth(), 1), 
                to: new Date()
            }),
            loading: false,
            metadata:
                [
                    {
                        label: 'id',
                        source: 'ID',
                        type: 'primary',
                        visible: false
                    },
                    {
                        label: 'Date / Time',
                        source: 'DATE',
                        type: 'date',
                    },
                    {
                        label: 'Duration',
                        source: 'DURATION',
                        type: 'time'
                    },
                    {
                        label: 'Num. Calls',
                        source: 'NUMCALLS',
                        type: 'text'
                    },
                    {
                        label: 'Sell Amount',
                        source: 'AMOUNT_OUT',
                        type: 'money2'
                    },
                    {
                        label: 'Buy Amount',
                        source: 'AMOUNT_IN',
                        type: 'money2'
                    },
                    {
                        label: 'Profit/Loss',
                        source: 'PROFIT',
                        type: 'money2'
                    },
                    {
                        label: 'Currency',
                        source: 'CURRENCY',
                        type: 'text'
                    }
                ]
        }
    }
    componentDidMount(){
        this.loadFromServer();
    }
    loadFromServer() {
        this.setState({loading: true});
        const filter = {
            from: this.state.daterange.get('from').valueOf()/1000,
            to: this.state.daterange.get('to').valueOf()/1000
        }
        let params = {};
        params.filter = filter;
        params.pagination = {page: this.state.offset/this.state.limit+1, perPage: this.state.limit }
 
        this.props.childProps.dataProvider.getList(this.state.url, params, this.props).then(
            response => {
                if (response.data !== undefined) {
                    this.setState({
                        datarows: response.data.data,
                        servermeta: response.data.metadata,
                        datalen: response.data.data.length,
                        loading: false
                    })
                } 
            }
        );
    }
    onLoadMore() {
        var offset = this.state.offset + this.state.limit;
        this.setState({
                offset: offset
            }, function () {
                this.loadFromServer()
            }
        );
    }
    onFilter(filter) {
        this.setState({
                offset: 0,
                filter:  filter.toJS()
            }, function () {
                this.loadFromServer()
            }
        );
    }
    render(){

        var data = {
            data: this.state.datarows,
            metadata: this.state.servermeta
        };
        var filter =
            [
                {
                    source: 'ATRENTM',
                    label: 'Date',
                    type: 'date_range',
                    default: {'from' : new Date(), 'to': new Date() }
                }
            ]
        return(
            <Panel title = "Billing Summary Report">
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel panel-default">
                                    <div className="panel-body">
                                        <form className="form-horizontal">
                                            <div className="row">
                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-2 control-label">from</label>
                                                        <div className="col-sm-4 input-group">
                                                            <DatePicker
                                                                className="form-control datepicker"
                                                                selected={ new Date(this.state.daterange.get('from')) }
                                                                onChange={ this.handleDateChange.bind(this, 'from') }
                                                                timeFormat="HH:mm"
                                                                dateFormat="yyyy-MM-dd"
                                                            />
                                                        </div>
                                                        <label className="col-sm-2 control-label">to</label>
                                                        <div className="col-sm-4 input-group">
                                                            <DatePicker
                                                                className="form-control datepicker"
                                                                selected={ new Date(this.state.daterange.get('to')) }
                                                                onChange={ this.handleDateChange.bind(this, 'to') }
                                                                showTimeSelect
                                                                dateFormat="yyyy-MM-dd"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <Button bsStyle="save" value="Filter" onClick={this.handleFilter.bind(this)}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <DaTable
                                    data={data}
                                    metadata={this.state.metadata}
                                    filter = {filter}
                                    onFilter = { this.onFilter.bind(this) }
                                    url={this.state.url}
                                    urlattrs={this.props.urlattrs}
                                    onLoadMore = { this.onLoadMore.bind(this) }
                                    datalen = { this.state.datalen }
                                    limit = { this.state.limit }
                                    offset = { this.state.offset }
                                    loading = { this.state.loading }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Panel>
        )
    }
}
